export default __webpack_public_path__ + "static/media/profile_img.b69d6746.jpg";